import { hashString } from './hashString';
/**
 * 计算普通对象的 hash 值
 */
export function hashObject(obj) {
    return hashString(JSON.stringify(obj));
}
